// Password generators for the sign-up screens. Two flavours: a memorable word-based passphrase
// and a strong random string. Both clear the backend strength floor (>=8 chars, a capital and a
// symbol) and a memorable one clears the stricter 12-char business floor too.

const WORDS = [
  "brave", "tiger", "maple", "river", "cloud", "ember", "harbor", "lunar", "meadow", "pepper",
  "quartz", "raven", "saffron", "thunder", "violet", "willow", "amber", "basil", "cobalt", "dune",
  "falcon", "ginger", "hazel", "indigo", "jasmine", "kernel", "lotus", "marble", "nectar", "olive",
  "pixel", "quiver", "ripple", "sunset", "timber", "umber", "velvet", "walnut", "yonder", "zephyr",
  "anchor", "breeze", "canyon", "delta", "echo", "forest", "granite", "hollow", "island", "jungle",
  "kettle", "lantern", "mango", "nimbus", "orchard", "pebble", "quill", "rocket", "silver", "tulip",
];

const SYMBOLS = "!?#$%&@*-+";

const randInt = (n) => {
  const buf = new Uint32Array(1);
  (window.crypto || window.msCrypto).getRandomValues(buf);
  return buf[0] % n;
};

const pick = (arr) => arr[randInt(arr.length)];
const cap = (w) => w.charAt(0).toUpperCase() + w.slice(1);

// e.g. "Brave-Tiger-Nest-47!" — easy to read aloud, still ~50 bits of entropy. `words` picks how
// many words go in (3–5): more words = longer and harder to guess.
export const memorablePassword = (words = 3) => {
  const count = Math.min(5, Math.max(3, Number(words) || 3));
  const chosen = [];
  while (chosen.length < count) {
    const w = pick(WORDS);
    if (!chosen.includes(w)) chosen.push(cap(w));
  }
  const num = String(10 + randInt(90));
  return `${chosen.join("-")}-${num}${pick(SYMBOLS.split(""))}`;
};

// A strong 16-char random string with at least one of each class.
export const randomPassword = (len = 16) => {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnpqrstuvwxyz";
  const digits = "23456789";
  const all = upper + lower + digits + SYMBOLS;
  const out = [pick(upper.split("")), pick(lower.split("")), pick(digits.split("")), pick(SYMBOLS.split(""))];
  while (out.length < len) out.push(pick(all.split("")));
  // Fisher–Yates shuffle so the guaranteed classes aren't always in front.
  for (let i = out.length - 1; i > 0; i--) {
    const j = randInt(i + 1);
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out.join("");
};
